import { render, staticRenderFns } from "./AIChatTextArea.vue?vue&type=template&id=5b4b0cc1&scoped=true"
import script from "./AIChatTextArea.vue?vue&type=script&lang=js"
export * from "./AIChatTextArea.vue?vue&type=script&lang=js"
import style0 from "./AIChatTextArea.vue?vue&type=style&index=0&id=5b4b0cc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b0cc1",
  null
  
)

export default component.exports